import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AuthService } from '../../../core/auth.service';


@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.css']
})
export class CreateClientComponent implements OnInit {

  
  public clientForm: FormGroup;
  title: string;
  questionType_selected: any;
  types_arr: any;

  public singleDate: any;

  constructor(private router: Router, private _fb: FormBuilder, private afs: AngularFirestore, private authService: AuthService) { }

  getControls(frmGrp: FormGroup, key: string) {
    return (<FormArray>frmGrp.controls[key]).controls;
  }

  ngOnInit() {
    if (this.authService.loggedInUserRole !== 'Admin') {
      this.router.navigate(['/home'])
    }

    var d = new Date();
    var n = 'doc_' + d.getTime();

    this.clientForm = this._fb.group({
      'client_id': n,
      'client_name': ['', Validators.required],
      'createdDate': d,
      'categories': this._fb.array([
        this._fb.group({
          'category': ['', Validators.required],
      
        })
      ])
    });
  }

  onSubmit() {
    if (this.clientForm.dirty && this.clientForm.valid) {

       const client_data = this.clientForm.value
   
    var setDoc = this.afs.collection('clients').doc(this.clientForm.value.client_id).set(client_data);
   alert("Client has been saved");
  this.router.navigateByUrl('/client/list');
 ///this.router.navigateByUrl('/calendar/list-post/' + this.doc_id);
 
  }
 
  }
  initbrand() {
    return this._fb.group({
      'category': ['', Validators.required],
    });
  }

  addCategory() {
    const control = <FormArray>this.clientForm.controls['categories'];
    control.push(this.initbrand());
  }
  removeCategory(i: number) {
    const control = <FormArray>this.clientForm.controls['categories'];
    control.removeAt(i);
  }


 
}


// WEBPACK FOOTER //
// ./src/app/auth/client/create-client/create-client.component.ts